import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

function createEventData(
    eventName: GA4EventName,
    featureCategory: GA4FeatureCategory,
    clickElement: string,
    clickText?: string,
    clickUrl?: string,
): Record<string, string> {
    return {
        eventName,
        feature_category: featureCategory,
        click_element: clickElement,
        ...(clickText && { click_text: clickText }),
        ...(clickUrl && { click_url: clickUrl }),
    };
}

export function trackTextlinkClick(label: string, clickText: string, clickUrl: string): void {
    const eventData = createEventData(
        GA4EventName.ClickTextLink,
        GA4FeatureCategory.FooterNavigation,
        label,
        clickText,
        clickUrl,
    );
    trackAnalyticsEvent({
        category: 'Footer',
        action: 'Click',
        label,
        eventData,
    });
}

export function trackSocialNetworkIconClick(label: string): void {
    const eventData = createEventData(
        GA4EventName.ClickButton,
        GA4FeatureCategory.FooterNavigation,
        label,
    );
    trackAnalyticsEvent({ eventData });
}

export function trackTrustpilot(clickUrl: string): void {
    const eventData = createEventData(
        GA4EventName.ClickTextLink,
        GA4FeatureCategory.FooterNavigation,
        'Trustpilot Widget',
        undefined,
        clickUrl,
    );
    trackAnalyticsEvent({ eventData });
}

export function trackNewsLetterSubscription(clickUrl: string): void {
    const eventData = createEventData(
        GA4EventName.ClickButton,
        GA4FeatureCategory.FooterNavigation,
        'Newsletter Subscription',
        'Abonnieren',
        clickUrl,
    );
    trackAnalyticsEvent({ eventData });
}
